import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DmcQuoteHelperService {

  dmcQuoteFormDefaultValues:any = null;

  constructor() { }

  private readonly storageKey = 'dmcQuoteFormDefaultValues';

  setDmcQuoteFormDefaultValues(defaultValues:any) {
    this.dmcQuoteFormDefaultValues = defaultValues;
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(defaultValues));
    } catch (e) {
      console.warn('Unable to save quote defaults to localStorage', e);
    }
  }

  getDmcQuoteFormDefaultValues() {
    if (this.dmcQuoteFormDefaultValues) {
      return this.dmcQuoteFormDefaultValues;
    }
    try {
      const stored = localStorage.getItem(this.storageKey);
      if (stored) {
        this.dmcQuoteFormDefaultValues = JSON.parse(stored);
      }
    } catch (e) {
      console.warn('Unable to read quote defaults from localStorage', e);
    }
    return this.dmcQuoteFormDefaultValues;
  }
}
